import * as React from "react";
import NavBar from "../components/NavBar";
import { RouteChildrenProps } from "react-router";
import AppUser from "../AppUser";

import { Table } from "react-bootstrap";

interface Props extends RouteChildrenProps {
    user: AppUser
}


export default class TopPage extends React.Component<Props, {}> {
    render() {
        return (
            <div>
                <NavBar {...this.props}/>
                <div style={{margin: "150px",align:"center"}}>
                    <h2 style={{textAlign: "center", marginBottom: "0px"}}>{"◆管理者向けおしらせ◆"}</h2>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>2019.04.17 サービス開始</td>
                            </tr>
                            <tr>
                                <td>2019.04.19 機能改善開発開始</td>
                            </tr>
                            <tr>
                                <td>2019.04.23 iPhone SE対応</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h2 style={{textAlign: "center", marginBottom: "0px"}}>{"◆おしらせ◆"}</h2>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>2019.04.17 サービス開始</td>
                            </tr>
                            <tr>
                                <td>2019.04.23 iPhone SE対応</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}
